
// client/src/components/owner/TenantAdd.jsx  (patched)
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function TenantAdd() {
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const [ownerData] = useState(() => {
    const stateData = location.state;
    const localData = localStorage.getItem('ownerData');
    return stateData || (localData ? JSON.parse(localData) : null);
  });

  const [formState, setFormState] = useState({
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    email: '',   // optional tenant contact email
    logo: null,
    waiver: null,
  });

  const [registerStatus, setRegisterStatus] = useState('');
  const [preview, setPreview] = useState({ logo: null, waiver: null });

  useEffect(() => {
    if (!ownerData || !ownerData.id) {
      setRegisterStatus('Owner ID is missing. Please log in again.');
      navigate('/ownerlogin');
    }
  }, [ownerData, navigate]);

  if (!ownerData) return <p>Loading owner info...</p>;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFormState((prev) => ({ ...prev, [name]: files[0] }));
      setPreview((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(files[0]),
      }));
    }
  };

  const registerTenant = async (e) => {
    e.preventDefault();

    if (!ownerData?.id) {
      setRegisterStatus('Owner ID is missing. Please log in again.');
      return;
    }

    const formData = new FormData();
    formData.append('ownerid', ownerData.id);

    // Only send address/contact + files; server will read the owner profile directly
    formData.append('address1', formState.address1);
    if (formState.address2) formData.append('address2', formState.address2);
    formData.append('city', formState.city);
    formData.append('state', formState.state);
    if (formState.zip) formData.append('zip', formState.zip);
    if (formState.email) formData.append('email', formState.email);

    if (formState.logo) formData.append('logo', formState.logo);
    if (formState.waiver) formData.append('waiver', formState.waiver);

    try {
      const response = await axios.post(`${baseUrl}/api/tenants/registertenant`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setRegisterStatus(response.data.message || 'Tenant registered successfully!');
      setTimeout(() => navigate('/login'), 1000);
    } catch (error) {
      console.error('Error registering tenant:', error.response?.data || error.message);
      setRegisterStatus(error.response?.data?.message || 'Failed to register tenant.');
    }
  };

  return (
    <div className="col-md-4">
      <div className="card">
        <div className="card-body">
          <h4 className="hdr hdr--primary hdr--lg">Create Tenant</h4>
          <form onSubmit={registerTenant}>
            <div className="form-group">
              <label htmlFor="email">Tenant Contact Email (optional):</label>
              <input
                className="textInput"
                type="email"
                name="email"
                value={formState.email}
                onChange={handleInputChange}
                placeholder="someone@yourtenant.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="address1">Address 1:</label>
              <input
                className="textInput"
                type="text"
                name="address1"
                value={formState.address1}
                onChange={handleInputChange}
                placeholder="Address 1"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="address2">Address 2:</label>
              <input
                className="textInput"
                type="text"
                name="address2"
                value={formState.address2}
                onChange={handleInputChange}
                placeholder="Address 2"
              />
            </div>

            <div className="form-group">
              <label htmlFor="city">City:</label>
              <input
                className="textInput"
                type="text"
                name="city"
                value={formState.city}
                onChange={handleInputChange}
                placeholder="City"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="state">State:</label>
              <input
                className="textInput"
                type="text"
                name="state"
                value={formState.state}
                onChange={handleInputChange}
                placeholder="State"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="zip">Zip:</label>
              <input
                className="textInput"
                type="text"
                name="zip"
                value={formState.zip}
                onChange={handleInputChange}
                placeholder="Zip"
              />
            </div>

            <div className="form-group">
              <label htmlFor="logo">Upload Logo:</label>
              <input type="file" name="logo" onChange={handleFileChange} />
              {preview.logo && <img src={preview.logo} alt="Logo Preview" style={{ width: '100px', marginTop: '10px' }} />}
            </div>

            <div className="form-group">
              <label htmlFor="waiver">Upload Waiver:</label>
              <input type="file" name="waiver" onChange={handleFileChange} />
              {preview.waiver && (
                <div style={{ marginTop: '10px' }}>
                  <p>{formState.waiver?.name}</p>
                </div>
              )}
            </div>

            <button className="btn btn-primary" type="submit">
              Register Tenant
            </button>
          </form>
          {registerStatus && <p>{registerStatus}</p>}
        </div>
      </div>
    </div>
  );
}

export default TenantAdd;
